
<form class="mt-3" role="form" novalidate #form="ngForm" method="post" (ngSubmit)="accept()">

    <div class="modal-custom">

      <div class="modal-header">
        <h4 class="modal-title"><i class="fa fa-exclamation-triangle text-danger"></i><span class="ml-2">Warning</span></h4>
        <button type="button" class="close" data-dismiss="modal" (click)="close()">×</button>
      </div>
      <!-- Modal Header End -->

      <div class="modal-body">
        <div>
          <div class="font-weight-bold">This will import {{numberOfUsers}} users to IDM</div>
          <div>This action cannot be undone.</div>

          <div class="row mt-3">
            <div class="col">

                <div class="form-group input-required">
                    <label for="domain">Domain</label>
                    <input id="domain" readonly maxlength="70" [(ngModel)]="domain" name="domain" type="text" class="form-control" required>
                </div>

              <div class="form-group input-required">
                <label for="crmID">CRM ID</label>
                <input id="crmID" readonly maxlength="50" [(ngModel)]="crmID" name="crmID" type="text" class="form-control" required>
              </div>

            </div>

          </div>
          <div class="mt-3">Do you want to import users to IDM?</div>
        </div>

        <div class="modal-footer mt-4">
          <button type="button" class="btn btn-cancel" data-dismiss="modal" (click)="close()">Cancel</button>
          <button type="submit" class="btn btn-primary" data-dismiss="modal" [disabled]="!form.valid">Import Users</button>
        </div>

      </div>
      <!-- Modal Body End -->
    </div>
    <!-- Modal Custom End -->
  </form>
